"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var themes_1 = require("../../themes");
exports.default = (0, styles_1.makeStyles)(function () {
    return (0, styles_1.createStyles)({
        icon: {
            display: 'flex',
            justifyContent: 'center',
            height: '100%',
            width: '100%',
            alignItems: 'center',
            borderRadius: '10px',
            border: "dashed 2px ".concat(themes_1.materialColors.blue[200]),
            textTransform: 'uppercase',
            '& > *': {
                display: 'block',
            },
        },
        hiddenFileInput: {
            opacity: 0,
            zIndex: -1,
            position: 'absolute',
        },
    });
});
